import { Box } from "@mui/material";

import SuccessTickIcon from "../../icons/SuccessTickIcon";
import { WalletType } from "../../enums";
import { usePaymentMethodImage } from "./usePaymentMethodImage";
export type FundButtonProps = {
  method: { id: WalletType; name: string };
  selected?: boolean;
  onClick: () => void;
};
export const FundButton = ({ method, selected, onClick }: FundButtonProps) => {
  const icon = usePaymentMethodImage(method.id);
  return (
    <Box
      sx={{
        bgcolor: "primary.main",
        cursor: "pointer",
        borderRadius: "0.9375rem",
        padding: "1.125rem 0.9375rem",
        width: "100%",
        backgroundColor: "#1d1c23",
        whiteSpace: "nowrap",
        overflow: "hidden",

        "&:hover": {
          backgroundColor: "primary.light",
        },
        ...(!!selected && {
          border: 1,
          backgroundColor: "none",
        }),
      }}
      onClick={onClick}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "1.25rem",
              width: "2.5rem",
              height: "2.5rem",
              backgroundColor: "primary.dark",
              overflow: "hidden",
            }}
          >
            <Box component={"img"} src={icon} />
          </Box>
          <span style={{ fontWeight: 600, textOverflow: "ellipsis" }}>{method.name}</span>
        </div>
        {typeof selected !== "undefined" && (
          <Box
            sx={{
              backgroundColor: "primary.dark",
              width: 30,
              height: 30,
              borderRadius: "15px",
              "& .MuiSvgIcon-root": {
                ...(!selected && {
                  display: "none",
                }),
              },
            }}
          >
            <SuccessTickIcon sx={{ color: "success.main", width: "100%", height: "100%" }} />
          </Box>
        )}
      </div>
    </Box>
  );
};
